import React from 'react';
import SignIn from '../../components/sign-in/sign-in.component';

const HomePage = () => {
  return (
    <div>
      <SignIn />
    </div>
  );
};

export default HomePage;
